import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT, IMAGES, NAV } from "../../data";
import { scrollToId } from "../../lib/scroll";
import { openInquiry } from "../../lib/inquiry";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (target) => {
    setOpen(false);
    scrollToId(target);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50" data-testid="site-header">
      {/* Top info bar */}
      <div className="hidden md:block bg-oyf-charcoal text-white text-sm">
        <div className="container-oyf flex items-center justify-between py-2">
          <span className="font-medium tracking-wide text-white/85">
            Expedited cargo-van freight across Canada and the United States
          </span>
          <a href={CONTACT.tel} className="flex items-center gap-2 font-semibold hover:text-oyf-yellow transition-colors" data-testid="topbar-phone">
            <Phone size={14} /> {CONTACT.phone}
          </a>
        </div>
      </div>

      {/* Main bar */}
      <div className={`transition-colors duration-300 ${scrolled ? "bg-white/90 backdrop-blur-md border-b border-oyf-grey shadow-sm" : "bg-white border-b border-transparent"}`}>
        <div className="container-oyf flex items-center justify-between h-[68px]">
          <button onClick={() => go("home")} className="flex items-center" aria-label="One York Freight home" data-testid="logo-home">
            <img src={IMAGES.logo} alt="One York Freight logo" className="h-11 md:h-14 w-auto" />
          </button>

          <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
            {NAV.map((n) => (
              <button
                key={n.target}
                onClick={() => go(n.target)}
                className="text-[15px] font-semibold text-oyf-black/80 hover:text-oyf-black relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-oyf-yellow hover:after:w-full after:transition-[width] after:duration-300"
                data-testid={`nav-${n.target}`}
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a href={CONTACT.tel} className="hidden md:flex lg:hidden items-center gap-1.5 text-oyf-black font-semibold" data-testid="header-phone-icon">
              <Phone size={18} />
            </a>
            <button
              onClick={() => openInquiry("Header Button")}
              className="hidden md:inline-flex items-center bg-oyf-yellow text-oyf-black font-bold text-sm px-5 py-2.5 rounded-md hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_#202124] transition-transform duration-200"
              data-testid="header-quote-btn"
            >
              Send Inquiry
            </button>
            <a href={CONTACT.tel} className="md:hidden text-oyf-black p-2" aria-label="Call now" data-testid="mobile-phone">
              <Phone size={20} />
            </a>
            <button className="lg:hidden text-oyf-black p-2" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu" data-testid="mobile-menu-toggle">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-b border-oyf-grey shadow-lg" data-testid="mobile-menu">
          <div className="container-oyf py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <button key={n.target} onClick={() => go(n.target)} className="text-left py-2.5 text-base font-semibold text-oyf-black border-b border-oyf-grey" data-testid={`mobile-nav-${n.target}`}>
                {n.label}
              </button>
            ))}
            <button onClick={() => { setOpen(false); openInquiry("Mobile Menu"); }} className="mt-3 bg-oyf-yellow text-oyf-black font-bold py-3 rounded-md" data-testid="mobile-quote-btn">
              Send Inquiry
            </button>
            <a href={CONTACT.tel} className="mt-2 flex items-center justify-center gap-2 border border-oyf-charcoal text-oyf-charcoal font-bold py-3 rounded-md">
              <Phone size={16} /> Call {CONTACT.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
